import React from "react";
import { Box } from "@chakra-ui/react";
import Navbar from "../components/Navbar";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { FeedTimeline } from "../feed";



const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            retry: 1,
            staleTime: 5 * 60 * 1000, // 5 minutes
        },
    },
});

const FeedPage = () => {
    return (
        <QueryClientProvider client={queryClient}>
            <Box h="100vh" display="flex" flexDirection="column">
                <Navbar />
                <Box flex="1" zIndex={1}>
                    <FeedTimeline />
                </Box>
            </Box>
        </QueryClientProvider>
    );
};

export default FeedPage;